import FastForward10 from './FastForward10'

export default FastForward10
// eslint-disable-next-line import/export
export * from './FastForward10'
